import appGlobalScript from '/opt/atlassian/pipelines/agent/build/src/global/globalInit.js';
export const globalScripts = appGlobalScript;
